import { Component } from '@angular/core';
import { inverseTableBackground } from '../../../data/bootstrap-table';

@Component({
	selector: 'app-inverse-table-background',
	templateUrl: './inverse-table-background.component.html',
	styleUrls: ['./inverse-table-background.component.scss']
})
export class InverseTableBackgroundComponent {
	public inverseTableBackground = inverseTableBackground;

	trackByDetails(index: number, item: any): number {
		return item.id; // or another unique identifier
	}
}
